import { z } from 'zod';
/**
 * Recados entre profissionais no prontuário (P3 do personal): a nutricionista e o personal
 * conversam sobre o mesmo paciente dentro da ficha, no lugar do WhatsApp solto. É a
 * teleconsultoria do art. 4º da Res. CONFEF 542/2024: fica registrada, com quem escreveu, para
 * quem e quando cada um leu. O paciente não vê; o texto é guardado cifrado.
 */
export const TEAM_NOTE_MAX = 1000;
export const TEAM_NOTE_TO_MAX = 6;
/** A profissão como aparece ao lado do nome ("Juliana · Nutrição"). */
export const PROFESSION_SHORT = {
    medico: 'Medicina',
    odontologia: 'Odontologia',
    nutricao: 'Nutrição',
    educacao_fisica: 'Educação física',
    psicologia: 'Psicologia',
    fisioterapia: 'Fisioterapia',
    estetica: 'Estética',
    outro: 'Outra área',
};
const isoDateTime = z.iso.datetime();
export const teamNotePersonSchema = z.object({
    userId: z.string(),
    name: z.string(),
    /** A profissão (rótulo curto), quando marcada na equipe. */
    role: z.string().nullable(),
});
export const teamNoteSchema = z.object({
    id: z.string(),
    patientId: z.string(),
    author: teamNotePersonSchema,
    text: z.string(),
    at: isoDateTime,
    /** Para quem foi, e quando cada um leu (nulo: ainda não leu). */
    to: z.array(teamNotePersonSchema.extend({ readAt: isoDateTime.nullable() })),
});
export const teamNotesSchema = z.object({
    notes: z.array(teamNoteSchema),
    /** Quem pode receber um recado sobre esse paciente (a equipe com acesso clínico, menos eu). */
    team: z.array(teamNotePersonSchema),
    /** Recados para mim ainda sem ler, nessa ficha. */
    unread: z.number().int().nonnegative(),
});
export const createTeamNoteSchema = z.object({
    text: z.string().trim().min(2).max(TEAM_NOTE_MAX),
    to: z.array(z.uuid()).min(1).max(TEAM_NOTE_TO_MAX),
});
/** A caixa de recados de quem atende: um item por paciente com recado sem ler. */
export const teamNoteInboxRowSchema = z.object({
    patientId: z.string(),
    patientName: z.string(),
    unread: z.number().int().positive(),
    last: z.object({ author: z.string(), text: z.string(), at: isoDateTime }),
});
